import { useEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { Button } from '@iwoca/orion';
import { REQUEST_CHANGE_ROUTER } from '@iwRouter/IwRouter.actions';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import TopUpStatusMessage from '../RequestMoreFundsPanel/TopUpStatusMessages/TopUpStatusMessage';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    redirectToDashboard: () =>
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            location: {
                pathname: '/'
            }
        })
});

export const DocsComplete = connect(
    null,
    mapDispatchToProps
)(({ redirectToDashboard }: ReturnType<typeof mapDispatchToProps>) => {
    useEffect(() => {
        tracking.ampli.applicationDocsComplete();
    }, []);

    return (
        <div className="m-auto text-center">
            <TopUpStatusMessage
                heading={
                    <FormattedMessage
                        id="_.outstanding_view.topup_form.docsCompleteHeading"
                        defaultMessage="Thanks for your application"
                    />
                }
                description={
                    <FormattedMessage
                        id="_.outstanding_view.topup_form.docsCompleteDescription"
                        defaultMessage="We'll aim to get back to you in 24 hours but please bear with us if we take a little longer."
                    />
                }
            />
            <Button onClick={() => redirectToDashboard()}>
                <FormattedMessage
                    id="_.outstanding_view.topup_form.backToDashboard"
                    defaultMessage="Back to dashboard"
                />
            </Button>
        </div>
    );
});
